import _createNonEnumerableProperty from "../internals/create-non-enumerable-property";
import _errorStackClear from "../internals/error-stack-clear";
import _errorStackInstallable from "../internals/error-stack-installable";
var exports = {};
var createNonEnumerableProperty = _createNonEnumerableProperty;
var clearErrorStack = _errorStackClear;
var ERROR_STACK_INSTALLABLE = _errorStackInstallable;

// non-standard V8
var captureStackTrace = Error.captureStackTrace;
exports = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);else createNonEnumerableProperty(error, "stack", clearErrorStack(stack, dropEntries));
  }
};
export default exports;